import { Plus, XCircle } from "@untitled-ui/icons-react";
import { Fragment } from "react";
import { Input } from "../ui/input";
import { Button } from "../ui/button";

interface ControlledTextInputListInputProps {
	value: string[];
	onChange: (newValue: string[]) => void;
	label?: string;
}

const TextInputList: React.FC<ControlledTextInputListInputProps> = ({
	value,
	onChange,
	label,
}) => {
	const handleChange = (index: number, newValue: string) => {
		const updated = [...value];
		updated[index] = newValue;
		onChange(updated);
	};

	const handleAdd = () => {
		onChange([...value, ""]);
	};

	return (
		<div className="flex flex-col gap-3 w-full">
			{label && <div className="text-text-secondary-blue">{label}</div>}

			{value.map((entity, index) => (
				<Fragment key={index}>
        <div className="flex items-center gap-2 w-full">
           <Input
             value={entity}
             onChange={(e) => handleChange(index, e.target.value)}
             placeholder={`Entité ${index + 1}`}
           />
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={() => {
              const updated = [...value];
              updated.splice(index, 1);
              onChange(updated);
            }}
            aria-label="Supprimer l'entité"
          >
            <XCircle className="h-4 w-4" />
          </Button>
        </div>
       </Fragment>
			))}

			<Button
				variant="ghost"
				type="button"
				onClick={handleAdd}
				className="self-start mt-2"
			>
				<Plus className="mr-1 h-4 w-4" />
				Ajouter une entité
			</Button>
		</div>
	);
};

export default TextInputList;
